import Tour from './index';
import '@html/tour_b/styles.scss';
import '@html/tour_b/async.scss';

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept('./', () => {
    console.clear();
    const tour = new Tour();
    tour.initiate();
  });
}

window.addEventListener('load', () => {
  const tour = new Tour();
  tour.initiate();
});
